<script>
    import CountdownTimer from "./CountdownTimer.svelte";
    import JupiterPriceComponent from "./JupiterPriceComponent.svelte";
    const targetDate = new Date("2024-11-08T15:00:00Z");
    // Function to toggle spin effect on image
    function toggleSpin(element) {
        element.classList.toggle("spin");
    }
</script>

<section>
<!--    <CountdownTimer {targetDate} />-->
    <JupiterPriceComponent />
    <div><h1>Welcome to Reyna Coin</h1></div>
    <div>
        <img
                class="reyna-coin-main-img"
                src="/images/reyna_1000x1000.png"
                alt="Reyna Coin"
                on:click={() => toggleSpin(document.querySelector(".reyna-coin-main-img"))}
        />
    </div>
    <div>
        <p>Introducing <b>Reyna</b>, the newest member of the ShepherdCoin family that was inspired by the beloved German
            Shepherd dog breed, known for its loyalty, intelligence, and versatility.</p>
        <p>Unleash the power of Reyna by becoming part of the ShepherdCoin Community and experience the perfect blend of
            fun that reflects the intelligence and reliability of the German Shepherd.</p>
    </div>

</section>

<style>
    section {
        /*min-height: 100vh; !* Full viewport height *!*/
        min-height: 100vh;
        max-width: 75%;
        display: flex;
        flex-direction: column;
        justify-content: center; /* Centers content vertically */
        align-items: center; /* Centers content horizontally */
        padding: 2rem;
        margin: 25pt auto 0 auto;
        text-align: center;
    }

    section p {
        max-width: 1000px;
        font-size: 18pt;
    }

    .reyna-coin-main-img {
        max-width: 500px;
        height: auto;
        cursor: pointer;
        transition: transform 0.5s;
    }

    .spin {
        transform: rotate(360deg);
    }

    p {
        margin: 1rem 0;
        font-size: 1.1rem;
        line-height: 1.6;
    }
</style>
